module.exports = __webpack_public_path__ + "media/images/icons/icon_language-9efa11c59805022edfe788fafd33b1ec.svg";